import * as defaultImport from "rxjs";
export * from "rxjs";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
